<template>
    <div>
      <el-card class="box-card">
        <el-form :model="editForm" ref="editFormRef" label-width="170px">
          <el-form-item label="产品名称" class="addAdminForm">
            <el-input v-model="editForm.projectname" disabled></el-input>
          </el-form-item>
          <el-form-item class="addAdminForm" label="计量单位">
            <el-input v-model="editForm.unit"></el-input>
          </el-form-item>
          <el-form-item class="addAdminForm" label="成本价">
            <el-input v-model="editForm.chengbenjia"></el-input>
          </el-form-item>
          <el-form-item class="addAdminForm" label="集团内部采购价">
            <el-input v-model="editForm.jituanneibucaigoujia"></el-input>
          </el-form-item>
          <el-form-item class="addAdminForm" label="预警限价">
            <el-input v-model="editForm.yujingxianjia"></el-input>
          </el-form-item>
          <el-form-item class="addAdminForm" label="预警限价折扣率">
            <el-input v-model="editForm.yujingxianjiazhekou"></el-input>
          </el-form-item>
          <el-form-item class="addAdminForm" label="预警限价起订量">
            <el-input v-model="editForm.yujingxianjiaqiding"></el-input>
          </el-form-item>
          <el-form-item class="addAdminForm" label="预警限价权限">
            <el-input v-model="editForm.yujingxianjiaquanxian"></el-input>
          </el-form-item>
          <el-form-item class="addAdminForm" label="贴牌价">
            <el-input v-model="editForm.tiepaijia"></el-input>
          </el-form-item>
          <el-form-item class="addAdminForm" label="贴牌价折扣率">
            <el-input v-model="editForm.tiepaijiazhekou"></el-input>
          </el-form-item>
          <el-form-item class="addAdminForm" label="贴牌起订量">
            <el-input v-model="editForm.tiepaijiaqiding"></el-input>
          </el-form-item>
          <el-form-item class="addAdminForm" label="数量小于5限价">
            <el-input v-model="editForm.xiaoyu5xianjia"></el-input>
          </el-form-item>
          <el-form-item class="addAdminForm" label="数量小于5限价折扣率">
            <el-input v-model="editForm.xiaoyu5xianjiazhekou"></el-input>
          </el-form-item>
          <el-form-item class="addAdminForm" label="市场销售价">
            <el-input v-model="editForm.shichangjia"></el-input>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clicksave">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  data () {
    return {
      editForm: {
        id: 0,
        projectname: '',
        unit: '',
        chengbenjia: '',
        jituanneibucaigoujia: '',
        yujingxianjia: '',
        yujingxianjiazhekou: '',
        yujingxianjiaqiding: '',
        yujingxianjiaquanxian: '',
        tiepaijia: '',
        tiepaijiazhekou: '',
        tiepaijiaqiding: '',
        xiaoyu5xianjia: '',
        xiaoyu5xianjiazhekou: '',
        shichangjia: ''
      }
    }
  },
  mounted () {
  },
  methods: {
    LoadData (row) {
      this.editForm.id = row.Id
      this.editForm.projectname = row.Projectname

      this.editForm.unit = row.Unit
      this.editForm.chengbenjia = row.Chengbenjia
      this.editForm.jituanneibucaigoujia = row.Jituanneibucaigoujia
      this.editForm.yujingxianjia = row.Yujingxianjia
      this.editForm.yujingxianjiazhekou = row.Yujingxianjiazhekou
      this.editForm.yujingxianjiaqiding = row.Yujingxianjiaqiding
      this.editForm.yujingxianjiaquanxian = row.Yujingxianjiaquanxian
      this.editForm.tiepaijia = row.Tiepaijia
      this.editForm.tiepaijiazhekou = row.Tiepaijiazhekou
      this.editForm.tiepaijiaqiding = row.Tiepaijiaqiding
      this.editForm.xiaoyu5xianjia = row.Xiaoyu5xianjia
      this.editForm.xiaoyu5xianjiazhekou = row.Xiaoyu5xianjiazhekou
      this.editForm.shichangjia = row.Shichangjia
    },
    clickreturn () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.apiEditErp6SaleBaseProductPrice()
    },
    apiEditErp6SaleBaseProductPrice: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      data = { ...data, ...that.editForm }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditErp6SaleBaseProductPrice, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 365px;
}
</style>
